import { AuctionLot } from '@nx/global-types'

import { LotGridLoader } from '@web/components/common/LotGridLoader'

import { LotGrid } from '../../common/LotGrid'

export const LotsPromoGrid = ({
  lots,
  isLoading,
  isNewLot = false,
  event,
}: {
  isNewLot?: boolean
  lots: AuctionLot[]
  isLoading: boolean
  event: {
    category: string
  }
}) =>
  isLoading ? (
    <LotGridLoader numberOfLoaders={24} />
  ) : lots?.length ? (
    <LotGrid
      lotTracking={{ category: event.category }}
      lots={lots}
      isShowingLotId={isNewLot}
    />
  ) : null
